import * as Yup from "yup";

export const initialValues = (data, occasionTypes) => {
  return {
    ...data,
    englishName: data?.localized_data?.en?.name,
    arabicName: data?.localized_data?.ar?.name,
    image: data?.image_url,
    occasion_type_ids: data?.occasion_type_ids?.map((id) => {
      const type = occasionTypes?.find((t) => t.id === id);
      return {
        label: type?.localized_data?.en?.name || type?.name || `Occasion ${id}`,
        value: id,
      };
    }),
  };
};

export const structure = (occasionTypes, _, t) => [
  {
    head: "",
    width: "100%",
    list: [
      {
        name: `image`,
        kind: "upload",
        type: "file",
        label: t("common.image"),
        width: "100%",
      },
      {
        name: `englishName`,
        kind: "input",
        type: "text",
        label: `${t("lookups_services.service_en")}*`,
        width: "47%",
      },
      {
        name: `arabicName`,
        kind: "input",
        type: "text",
        label: `${t("lookups_services.service_ar")}*`,
        width: "47%",
      },
      {
        name: "occasion_type_ids",
        label: t("lookups_services.occasion_types"),
        kind: "multiSelect",
        options: occasionTypes?.map((item) => ({
          id: item.id,
          name: item.localized_data?.en?.name || item.name,
        })),
        width: "100%",
      },
    ],
  },
];

export const validationSchema = () =>
  Yup.object({
    englishName: Yup.string().required("required"),
    arabicName: Yup.string().required("required"),
    occasion_type_ids: Yup.array().min(
      1,
      "at least one occasion type required"
    ),
  });
